import Client from "../baseClient";
import { Tax } from "~/entities/taxEntities";

export const TaxApi = {
  getTaxes: async (orgId: string, siteId: string) =>
    await Client.get<Tax[]>(`${orgId}/${siteId}/taxes`),
};
